import { z } from 'zod'

import { UsersValueRecommendationType } from 'apps/dashboard/components/HomeTab/UsersValue/models/UsersValuePeriodData'
import { IgUsersValuePeriod } from 'apps/dashboard/constants/IgUsersValueConstants'

export const RecommendationSchema = z
  .object({
    type: z.enum([
      UsersValueRecommendationType.Comments,
      UsersValueRecommendationType.StoryReplies,
      UsersValueRecommendationType.DirectMessages,
    ]),
    quick_campaign_id: z.number(),
  })
  .or(
    z.object({
      type: z.enum([UsersValueRecommendationType.StoryMentions]),
      quick_campaign_id: z.null(),
    }),
  )

export const IgUsersValueSchema = z
  .object({
    default_active_period: z.enum(IgUsersValuePeriod),
    all_auto_interactions_1d: z.number(),
    all_auto_interactions_1d_percent: z.number(),
    all_auto_interactions_7d: z.number(),
    all_auto_interactions_7d_percent: z.number(),
    all_interactions_1d: z.number(),
    all_interactions_7d: z.number(),
    auto_comments_1d: z.number(),
    auto_comments_1d_percent: z.number(),
    auto_comments_7d: z.number(),
    auto_comments_7d_percent: z.number(),
    auto_story_mentions_1d: z.number(),
    auto_story_mentions_1d_percent: z.number(),
    auto_story_mentions_7d: z.number(),
    auto_story_mentions_7d_percent: z.number(),
    auto_story_replies_1d: z.number(),
    auto_story_replies_1d_percent: z.number(),
    auto_story_replies_7d: z.number(),
    auto_story_replies_7d_percent: z.number(),
    comments_1d: z.number(),
    comments_7d: z.number(),
    ig_enable_dttm: z.string(),
    story_mentions_1d: z.number(),
    story_mentions_7d: z.number(),
    story_replies_1d: z.number(),
    story_replies_7d: z.number(),
    statistics_readiness_date: z.string().optional(),
    direct_1d: z.number(),
    direct_7d: z.number(),
    auto_direct_1d: z.number(),
    auto_direct_1d_percent: z.number(),
    auto_direct_7d: z.number(),
    auto_direct_7d_percent: z.number(),
    recommendations: z.array(RecommendationSchema),
  })
  .nullable()
